/**
 * Created by vsliwka on 21/04/2017.
 */
/**
 * Created by vsliwka on 20/04/2017.
 */
export class WorkVersionUsedModel {
  public id: number;
  public label: string;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
